// Copyright (c) 2016 Deere & Company

import TrackClaimContainer from '../../claim/track/state-connector';

export default {
    component: TrackClaimContainer,
    name: 'TRACK_CLAIM',
    path: 'track/edit/:claimNumber'
};



// WEBPACK FOOTER //
// ./src/routes/claims/edit-track-claim-route.js